const StickyCTA = ({onEnquire}) => {
  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t p-2 flex justify-between gap-1 lg:hidden z-50">
      <a
        href="tel:+91 93269 59938"
        className="flex flex-col items-center bg-[#7c9a1f] w-full text-white px-6 py-2 rounded-lg"
      >
        <img
          src="/Images/callus.gif"
          alt="Godrej Varanya call us"
          className="w-6 h-6 invert brightness-200"
        />
        Call
      </a>
      <button
        className="flex flex-col items-center bg-[#7c9a1f] w-full text-white px-6 py-2 rounded-lg"
        onClick={onEnquire}
      >
        <img
          src="/Images/download.gif"
          alt="Godrej Varanya enquire"
          className="w-6 h-6 invert brightness-200"
        />
        Enquire
      </button>
      <a
        href="https://api.whatsapp.com/send?phone=9326959938&text=I am interested in Godrej Varanya, Kharghar project and want more information about this project."
        className="flex flex-col items-center bg-[#7c9a1f] w-full text-white px-6 py-2 rounded-lg"
        target="_blank" rel="noreferrer"
      >
        <img
          src="/Images/WhatsApp.gif"
          alt="Godrej Varanya contact"
          className="w-6 h-6 invert brightness-200"
        />
        WhatsApp
      </a>
    </div>
  );
};

export default StickyCTA;
